import { apiGet, apiPost } from '../../api/api-configuration';
import { failureAction } from '../../app-actions';
import {
  API_GET_FFWD_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_GET_FFWD_CUSTOMER_DATA,
  API_COMPLETE_GET_FFWD_CUSTOMER_DATA,
  API_POST_FFWD_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_SUBMIT_FFWD_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_FFWD_CUSTOMER_DATA,
  COMPLETE_FFWD_CALLBACK_REQUEST,
  FFWD_CALLBACK_REQUEST_ENDPOINT,
  INITIATE_FFWD_CALLBACK_REQUEST,
} from '../../app-constants';

export const successActionFFWDCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_GET_FFWD_CUSTOMER_DATA, data };
};

export const getFFWDCustomerData = data => (dispatch) => {
  const endpoint = `${API_GET_FFWD_CUSTOMER_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: API_INITIATE_GET_FFWD_CUSTOMER_DATA });
  apiGet(dispatch, endpoint, successActionFFWDCustomerData, failureAction, data);
};

export const successActionSubmitFFWD = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_SUBMIT_FFWD_CUSTOMER_DATA, data };
};

export const submitFFWDCustomerData = data => (dispatch) => {
  const endpoint = API_POST_FFWD_CUSTOMER_DATA_ENDPOINT;
  const dataWithEncryptedCidn = {
    ...data,
    value: window.parent.tcom.researchInsights.appConfig.currentAccount,
  };
  dispatch({ type: API_INITIATE_SUBMIT_FFWD_CUSTOMER_DATA });
  apiPost(dispatch, endpoint, successActionSubmitFFWD, failureAction, dataWithEncryptedCidn);
};

export const successfulSubmissionOfFFWDRequestCallback = (response) => {
  const { data } = response;
  return { type: COMPLETE_FFWD_CALLBACK_REQUEST, data };
};

export const submitFFWDRequestCallback = data => (dispatch) => {
  const endpoint = FFWD_CALLBACK_REQUEST_ENDPOINT;
  const dataWithEncryptedCidn = {
    ...data,
    value: window.parent.tcom.researchInsights.appConfig.currentAccount,
  };
  dispatch({ type: INITIATE_FFWD_CALLBACK_REQUEST });
  apiPost(dispatch, endpoint, successfulSubmissionOfFFWDRequestCallback, failureAction, dataWithEncryptedCidn);
};

export const formatPhoneNumber = (number) => {
  let finalString = '';
  if (number.length === 11) {
    finalString = `${number.substring(0, 5)} ${number.substring(5, 8)} ${number.substring(8)}`;
  } else if (number.length === 10) {
    finalString = `${number.substring(0, 4)} ${number.substring(4, 7)} ${number.substring(7)}`;
  } else {
    finalString = number;
  }
  return finalString;
};
